import { render, staticRenderFns } from "./SnackbarContainer.vue?vue&type=template&id=4c8be1c3&scoped=true&"
import script from "./SnackbarContainer.vue?vue&type=script&lang=js&"
export * from "./SnackbarContainer.vue?vue&type=script&lang=js&"
import style0 from "./SnackbarContainer.vue?vue&type=style&index=0&id=4c8be1c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8be1c3",
  null
  
)

export default component.exports